import { render, staticRenderFns } from "./MarketplaceSiteBuilder.vue?vue&type=template&id=a1123b34&"
import script from "./MarketplaceSiteBuilder.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSiteBuilder.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceSiteBuilder.vue?vue&type=style&index=0&id=a1123b34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports